import { render } from 'preact';
import './styles/app.css';
import { App } from './app.tsx';

const root = document.getElementById('app');
if (root) render(<App />, root);

// Two-finger pinch and double-tap zoom would fight the drawing surface.
document.addEventListener('gesturestart', (e) => e.preventDefault());
document.addEventListener('dblclick', (e) => e.preventDefault());

// Offline play. Registered after load so it never delays first paint.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}
